// Soft Drinks card game data - ranked by sales and popularity
export const SOFT_DRINKS_CARDS = [
  { id: 1, name: "Coca-Cola", rank: 1, image: "/images/softDrinks/softDrinks_1.jpg" },
  { id: 2, name: "Pepsi", rank: 2, image: "/images/softDrinks/softDrinks_2.jpg" },
  { id: 3, name: "Dr Pepper", rank: 3, image: "/images/softDrinks/softDrinks_3.jpg" },
  { id: 4, name: "Mountain Dew", rank: 4, image: "/images/softDrinks/softDrinks_4.jpg" },
  { id: 5, name: "Sprite", rank: 5, image: "/images/softDrinks/softDrinks_5.jpg" },
  { id: 6, name: "Diet Coke", rank: 6, image: "/images/softDrinks/softDrinks_6.jpg" },
  { id: 7, name: "Fanta", rank: 7, image: "/images/softDrinks/softDrinks_7.jpg" },
  { id: 8, name: "7UP", rank: 8, image: "/images/softDrinks/softDrinks_8.jpg" },
  { id: 9, name: "A&W Root Beer", rank: 9, image: "/images/softDrinks/softDrinks_9.jpg" },
  { id: 10, name: "Ginger Ale", rank: 10, image: "/images/softDrinks/softDrinks_10.jpg" },
  { id: 11, name: "Sunkist", rank: 11, image: "/images/softDrinks/softDrinks_11.jpg" },
  { id: 12, name: "Crush", rank: 12, image: "/images/softDrinks/softDrinks_12.jpg" },
  { id: 13, name: "Barq's Root Beer", rank: 13, image: "/images/softDrinks/softDrinks_13.jpg" },
  { id: 14, name: "Sierra Mist", rank: 14, image: "/images/softDrinks/softDrinks_14.jpg" },
  { id: 15, name: "Mug Root Beer", rank: 15, image: "/images/softDrinks/softDrinks_15.jpg" },
  { id: 16, name: "Minute Maid", rank: 16, image: "/images/softDrinks/softDrinks_16.jpg" },
  { id: 17, name: "Squirt", rank: 17, image: "/images/softDrinks/softDrinks_17.jpg" },
  { id: 18, name: "Fresca", rank: 18, image: "/images/softDrinks/softDrinks_18.jpg" },
  { id: 19, name: "Canada Dry", rank: 19, image: "/images/softDrinks/softDrinks_19.jpg" },
  { id: 20, name: "RC Cola", rank: 20, image: "/images/softDrinks/softDrinks_20.jpg" },
  { id: 21, name: "Big Red", rank: 21, image: "/images/softDrinks/softDrinks_21.jpg" },
  { id: 22, name: "Cheerwine", rank: 22, image: "/images/softDrinks/softDrinks_22.jpg" },
  { id: 23, name: "Jarritos", rank: 23, image: "/images/softDrinks/softDrinks_23.jpg" },
  { id: 24, name: "Orange Crush", rank: 24, image: "/images/softDrinks/softDrinks_24.jpg" },
  { id: 25, name: "Grape Fanta", rank: 25, image: "/images/softDrinks/softDrinks_25.jpg" },
  { id: 26, name: "Cherry Coke", rank: 26, image: "/images/softDrinks/softDrinks_26.jpg" },
  { id: 27, name: "Cream Soda", rank: 27, image: "/images/softDrinks/softDrinks_27.jpg" },
  { id: 28, name: "Vernors", rank: 28, image: "/images/softDrinks/softDrinks_28.jpg" },
  { id: 29, name: "Tab", rank: 29, image: "/images/softDrinks/softDrinks_29.jpg" },
  { id: 30, name: "Shasta", rank: 30, image: "/images/softDrinks/softDrinks_30.jpg" }
];
